import { AdminListUsersFilter, User, UserStatus } from '../../graphql/API';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminGetNextPendingUserApi = async (): Promise<User[]> => {
  const filter: AdminListUsersFilter = { status: UserStatus.pending, limit: 10 };
  const result = await executeGql<User[]>(adminListUsersQuery, { filter });
  const processedResult: User[] = processGqlResult<User[]>('adminListUsers.items', result);
  return processedResult;
};

const adminListUsersQuery = /* GraphQL */ `
  query AdminListUsersQuery($filter: AdminListUsersFilter!) {
    adminListUsers(filter: $filter) {
      items {
        id
      }
    }
  }
`;
